/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import { gql } from '@apollo/client';

const findCategoryProducts = (targetingEnabled, experimentService = false, dynamicPriceInGql = false) => (gql`
        query CategoryProductQuery($productOptions: ProductOptions, $brand: String!, $environment: String!, $id: String!, $locale: String!, $zipCode: String!, $locationType: String!${targetingEnabled ? ', $targeting: [Targeting]' : '' }) {
            findCategoryById(brand: $brand, environment: $environment, id: $id, locale: $locale, productOptions: $productOptions, zipCode: $zipCode, locationType: $locationType${targetingEnabled ? ', targeting: $targeting' : ''}) {
                products {
                    id
                    brandId
                    is3dEnabled
                image {
                    additionalImages
                    altText
                    name
                    path
                    snipe
                    snipeImagePath
                    snipeProductEndDate
                    snipeCategoryEndDate
                    snipeProductStartDate
                    snipeCategoryStartDate
                    collectionImage
                    __typename
                }
                productType
                reviews
                partNumber
                baseCode
                prices {
                    ${dynamicPriceInGql ? 'skuPartNumber display adjustment total displayCharges charges { label amount} ' : ''}
                    currency
                    type
                    value
                    __typename
                }
                skuPriceRange {
                    sale {
                        value
                    }
                    retail {
                        value
                    }
                    __typename
                }
                name
                brand
                seo {
                    url
                    __typename

                }
                showShopName
                productSkus {
                    marketplaceShopName
                    partNumber
                    id
                    __typename
                }
                isPassportEligible
                isPersonalizable
                availability {
                    availabilityIndicator
                    deliveryDateType
                    displayEndDate
                    displayStartDate
                    earliestShipDate
                    latestShipDate
                    perishable
                    productDeliveryType
                    shipAlone
                    deliveryMessage
                    __typename
                }
                __typename
            }
            totalProducts
            attributionToken
            source
            ${experimentService ? 'experiments' : ''}
            __typename
        }
    }
`);

export default findCategoryProducts;
